export default "__VITE_ASSET__7d543ae4__"